import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Constants } from '@app/constants';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { SignalrService } from '@app/core/signalr.service';
import { CheckPermission, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { AgentStatusService } from '../../services/agentstatus.service';
import { InsightsDashboardTab, NavService } from '../../services/nav.service';
import { NotificationsService } from '../../services/notifications.service';
import { DOCUMENT } from '@angular/common';
import { ConversationService } from '../../features/chat/services/conversation/conversation.service';
import { ToastService } from '../../services/toast/toast.service';
import { CallMonitorService } from '@projects/supervisor/src/app/services/call-monitor.service';
import { AlertService } from '../../services/alert.service';


@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit, OnDestroy {
  currentUser: any = {};
  shortName: string = '';
  showTopBarData = true;
  isAgent: boolean = false;
  isSupervisor: boolean = false;
  isQA: boolean = false;
  isAdmin: boolean = false;
  isConnectHub: boolean = false;
  isIbexProvider: boolean = false;
  provider = '';
  isAgentPermission: boolean = false;
  _centerData = {
    centerView: '',
    centerViewTooltip: ''
  };

  OutboundBusinessHours: Array<{ code: string, flag: string, dayName: string, hours: string, isBusinessDay: boolean, isPause: boolean }> = [];
  InsightsDashboardTab = InsightsDashboardTab;
  centerViewTabs: Array<any> = [];
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public authService: AuthenticationService,
    public navService: NavService,
    public notificationsService: NotificationsService,
    public statusService: AgentStatusService,
    public telephonyState: TelephonyStateService,
    private telephony: TelephonyProvider,
    private signalRService: SignalrService,
    public conversationService: ConversationService,
    private toastService: ToastService,
    public router: Router,
    public callMonitorService: CallMonitorService,
    public alertService: AlertService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        const agentPath = event.url.toLocaleLowerCase().search(/agent/g) > -1;
        const supervisorPath = event.url.toLocaleLowerCase().search(/supervisor/g) > -1;
        const adminPath = event.url.toLocaleLowerCase().search(/admin/g) > -1;
        const qaPath = event.url.toLocaleLowerCase().search(/qa/g) > -1;
        if (supervisorPath || adminPath || qaPath) {
          this.showTopBarData = false;
        } else {
          this.showTopBarData = true;
        }
      }
    });

    this.isAgent = CheckPermission('agent_chat', '', this.authService);

  }
  ngOnDestroy(): void {

  }
  disableLogout: boolean = false;

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      const { FirstName, LastName, Email, Features, AssignedApp } = this.authService.authData;
      this.currentUser = { FirstName, LastName, Email };
      this.shortName = this.authService.getUserInitials();
      this.provider = this.authService.authData?.ClientInfo?.Provider?.TelephoneProvider?.toLowerCase();
      this.isIbexProvider = this.provider === 'ibex' ? true : false;
      this.isSupervisor = AssignedApp.includes('Sightline');
      this.isQA = AssignedApp.includes('QA');
      this.isAdmin = AssignedApp.includes('Backstage');
      this.isConnectHub = AssignedApp.includes('ConnectHub');
      const isAgentCallPermission = Features.find((x: any) => x.Name === 'agent_calls');
      this.isAgentPermission = isAgentCallPermission ? true : false;
    }
    const centers = this.authService.getAllAssignedCenters() ?? [];
    const centerList = centers.map((center: any) => ({ Name: center.Description, Code: center.Code }));
    centerList.unshift({ Name: 'All', Code: '' });
    this.navService.onCenterChangeEvent$.subscribe((e) => {
      const centerId = centerList.find((c: any) => c.Code === e.centerId);
      this._centerData.centerView = centerId?.Code ? centerId?.Code : 'All';
      this._centerData.centerViewTooltip = centerId?.Code ? centerId?.Name : 'All';
      this.centerViewTabs = [];
      if (this._centerData.centerView === 'All') {
        const codes: string[] = [];
        const descriptions: string[] = [];
        centers.forEach((c: any) => {
          if (c.Code) {
            codes.push(c.Code);
            descriptions.push(c.Description);
          }
        });
        this._centerData.centerView = codes.join(' | ');
        this._centerData.centerViewTooltip = descriptions.join(' | ');
      }
      const campaignCode = e.campaignCode ? e.campaignCode : 'All';
      if (campaignCode !== 'All') {
        this._centerData.centerView = `${this._centerData.centerView} (${campaignCode})`;
        this._centerData.centerViewTooltip = `${this._centerData.centerViewTooltip} (${campaignCode})`;
      }
      centers.forEach((c: any) => {
        if (c.Code) {
          this.centerViewTabs.push({ id: c.Code, name: c.Description, enabled: true, isActive: false, show: true });
        }
      });
      if (this.centerViewTabs.length) {
        if (this.centerViewTabs.length > 1) {
          this.centerViewTabs.unshift({ id: '', name: 'All', enabled: true, isActive: false, show: true });
          const centerIndex = this.centerViewTabs.findIndex((c: any) => c.id === e.centerId);
          if (centerIndex !== -1) {
            this.centerViewTabs[centerIndex].isActive = true;
            if (campaignCode !== 'All') {
              this.centerViewTabs[centerIndex].name = this.centerViewTabs[centerIndex].name + ` (${campaignCode})`;
            }
          } else {
            this.centerViewTabs[0].isActive = true;
          }
        } else {
          if (campaignCode !== 'All') {
            this.centerViewTabs[0].name = this.centerViewTabs[0].name + ` (${campaignCode})`;
          }
          this.centerViewTabs[0].isActive = true;
        }
      }
      // console.log(this.centerViewTabs)
    })
    const isOutboundDialerEnabled = CheckPermission(
      'insights_dashboard',
      'insights_dashboard_outboundDialerSetting',
      this.authService
    );
    if (isOutboundDialerEnabled) {
      this.getOutboundBusinessHours();
    }
  }

  public centerViewTab(event: any) {
    if (this.centerViewTabs.length > 1) {
      this.navService.onCenterTabChangeEvent$.next({ center: event, isTabSelection: true });
    }
  }
  public getOutboundBusinessHours() {
    this.authService.getOutboundBusinessHours().subscribe((response: any) => {
      const { Data } = response;
      // const businessData = [
      //   { CountryCode: 'US', IsPause: false, Day: 2, Start: 0, End: 23, IsBusinessDay: true },
      //   { CountryCode: 'CA', IsPause: true, Day: 2, Start: 0, End: 23, IsBusinessDay: true },
      //   { CountryCode: 'AU', IsPause: false, Day: 2, Start: 0, End: 23, IsBusinessDay: true },
      //   { CountryCode: 'GB', IsPause: true, Day: 2, Start: 0, End: 23, IsBusinessDay: true }
      // ];
      const businessData: Array<any> = Data;
      const days: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      // const formatTime = (hour: number): string => {
      //   const date = new Date();
      //   date.setUTCHours(hour, 0, 0, 0); // treat input as UTC

      //   return date.toLocaleString('en-US', {
      //     hour: 'numeric',
      //     minute: '2-digit',
      //     hour12: true,
      //     timeZone: 'America/New_York',
      //   });
      // }
      const formatTime = (hour: number): string => {
        const suffix = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
        return `${formattedHour} ${suffix}`;
      };
      const flagMap: any = {
        US: 'usa.svg',
        CA: 'canada.svg',
        AU: 'australia.svg',
        GB: 'uk.svg',
        NZ: 'nz.svg',
        UST: 'usa.svg'
      };
      businessData.forEach(item => {
        this.OutboundBusinessHours.push({
          code: item.CountryCode,
          flag: '/assets/styles/assets/images/' + (flagMap[item.CountryCode] || 'default.svg'),
          dayName: days[item.Day],
          isBusinessDay: item.IsBusinessDay,
          isPause: item.IsPause,
          hours: item.IsBusinessDay
            ? `${formatTime(item.Start)} - ${formatTime(item.End)}`
            : 'Off Business Hours',
        });
      });
    }, error => {
      console.error('Error fetching outbound business hours:', error);
    });
  }
  onNavigateToMyAccount(e: Event) {
    e.preventDefault();
    let user = this.authService.authData;
    const isAgent = user?.AssignedApp.includes('ConnectHub');
    const isSupervisor = user?.AssignedApp.includes('Sightline');
    const isQA = user?.AssignedApp.includes('QA');
    const isAdmin = user?.AssignedApp.includes('Backstage');
    if (isAgent) {
      this.router.navigate(['/agent/settings/my-account']);
    } else if (isSupervisor) {
      this.router.navigate(['/supervisor/insight/settings/my-account']);
    } else if (isQA) {
      this.router.navigate(['/QA/evaluation/settings/my-account']);
    } else if (isAdmin) {
      this.router.navigate(['/admin/settings/my-account']);
    }
  }
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.removeItem('last_status');
    this.router.navigate(['logout']);
    // if (CheckPermission('agent_chat', '', this.authService)) {
    //   var activeChats = this.conversationService.hasPendingChats().subscribe((data: any) => {
    //     if (data) {
    //       debugger;
    //       this.toastService.info('You cannot log out because you have active chats.');
    //       return;
    //     }
    //     localStorage.removeItem('last_status');
    //     this.router.navigate(['logout']);
    //   });
    // } else {
    //   localStorage.removeItem('last_status');
    //   this.router.navigate(['logout']);
    // }
  }

  handleProfileDropdown() {
    const profileContext = !this.navService.getProfileContext();
    const topbarDropdown: HTMLDivElement = this.document.querySelector('.topbar')!;
    if (topbarDropdown) topbarDropdown.style.zIndex = profileContext ? '29' : '31';

    this.navService.setProfileContext(profileContext);
  }

  onClickOutSideOfProfileContext(e: any) {
    const topbarDropdown: HTMLDivElement = this.document.querySelector('.topbar')!;
    if (topbarDropdown) topbarDropdown.style.zIndex = '31';

    this.navService.setProfileContext(false);
  }
  onClickOutSideOfCallContext(e: any) {
    this.navService.setCallContext(false);
  }

  changeStatus(status: string) {
    if (this.statusService.loading) {
      this.toastService.info('Please wait, status is being updated.');
      return;
    }
    if (this.alertService.isAnyAlertExist(status)) {
      this.toastService.info(`Please mark the ${status} alert as acknowledge and try again`);
      return;
    }
    this.statusService.updateStatus(status);
    this.navService.setCallContext(false);
  }
  showDialpadIcon() {
    if (
      this.telephonyState.onCall ||
      this.statusService.currentStatus.FriendlyName === Constants.STATUSES.ManualCall.FriendlyName
    ) {
      return true;
    }
    return false;
  }
  isSignalRConnected() {
    return this.signalRService.isConnected();
  }
  getSignalRState() {
    return this.signalRService.ConnectionState();
  }
  getInternetStatusText() {
    const signalRStatus = this.isSignalRConnected() ? 'Connected' : 'Not Connected';

    return 'Internet: ' + signalRStatus;
  }
  reconnectVoice() {
    this.telephony.voice.reconnectVoice(null);
  }
  showHideStatus(status: string) {
    if (this.telephonyState.onCall && status == 'Wait') {
      return false;
    }
    if (status == this.statusService.currentStatus.FriendlyName) {
      return false;
    }
    return true;
  }
  get voiceStatusConfig() {
    if (!this.isAgentPermission) return null;

    if (!this.telephonyState.voiceStatus && this.telephonyState.voiceRegistered &&
      !this.statusService.loading && !this.telephonyState.onCall) {
      return {
        tooltip: 'Reconnect Voice',
        class: 'status--disconnected',
        icon: '/assets/styles/assets/images/headphone-disconnected.svg',
        badge: '/assets/styles/assets/images/status-disconnected.svg',
        click: () => this.reconnectVoice()
      };
    }

    if (this.telephonyState.voiceStatus && this.telephonyState.voiceRegistered) {
      return {
        tooltip: 'Voice Connected',
        class: 'status--connected',
        icon: '/assets/styles/assets/images/headphone-connected.svg',
        badge: '/assets/styles/assets/images/status-connected.svg'
      };
    }

    if (!this.telephonyState.voiceStatus && this.statusService.loading) {
      return {
        tooltip: 'Voice Connecting',
        class: 'status--connecting',
        icon: '/assets/styles/assets/images/headphone-connected.svg',
        badge: '/assets/styles/assets/images/wifi.svg'
      };
    }

    return {
      tooltip: 'Voice Not Connected',
      class: 'status--connecting',
      icon: '/assets/styles/assets/images/headphone.svg'
    };
  }
  get insightVoiceConfig() {
    if (!this.isSupervisor) return null;
    if (this.telephonyState.insightsVoice.registered) {
      if (this.telephonyState.insightsVoice.voice)
        return {
          tooltip: 'Insight Voice Connected',
          class: 'status--connected',
          icon: '/assets/styles/assets/images/headphone-connected.svg',
          badge: '/assets/styles/assets/images/status-connected.svg'
        };
      else {
        return {
          tooltip: 'Voice Not Connected',
          class: 'status--connecting',
          icon: '/assets/styles/assets/images/headphone.svg'
        };
      }
    }
    return null;
  }

  public onAction(event: any) {
    this.alertService.onAction(event)
  }

}
